module.exports = __webpack_public_path__ + "img/download-banner.1abad5ad.jpg";